import type { ActionDto } from "@puszczyk/contracts";
import type { BadgeTone } from "../../ui/Badge";

export const STATUS_TONE: Record<ActionDto["status"], BadgeTone> = {
  planned: "blue",
  active: "green",
  suspended: "yellow",
  closed: "neutral",
};
